var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFeature6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69611",
    "data-name": "Group 69611",
    transform: "translate(-944 -2156)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Path",
    width: 64,
    height: 64,
    rx: 2,
    transform: "translate(944 2156)",
    fill: "rgba(251,139,35,0.1)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_50726",
    "data-name": "Group 50726",
    transform: "translate(26 -151)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Path-2",
    "data-name": "Path",
    width: 40,
    height: 40,
    rx: 2,
    transform: "translate(930 2319)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_20615",
    "data-name": "Rectangle 20615",
    transform: "translate(933 2325)",
    fill: "none",
    stroke: "#fb8b23",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 28,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 31,
    height: 25,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_20616",
    "data-name": "Rectangle 20616",
    transform: "translate(939 2331)",
    fill: "none",
    stroke: "#fb8b23",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 12,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 12,
    height: 10,
    rx: 2,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_3463",
    "data-name": "Line 3463",
    y2: 9,
    transform: "translate(985.5 2181.5)",
    fill: "none",
    stroke: "#fb8b23",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3464",
    "data-name": "Line 3464",
    x2: 22,
    transform: "translate(965 2195)",
    fill: "none",
    stroke: "#fb8b23",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature6);
export default __webpack_public_path__ + "static/media/feature6.c16cff4216de7adff2ff7dc71b8ad6e2.svg";
export { ForwardRef as ReactComponent };